import { EducationRoute } from '@/modules/education/v1/api/EducationRoute'
import { EnumRouteType } from '@/contracts/core/api/enum/EnumRouteType'
import { ApiResponse } from '@/contracts/core/api/entity/ApiResponse'
import { ChangeQuestionParams } from '@/modules/education/v1/api/v1/questions/Dto/ChangeQuestionParams'
import { QuestionUuid } from '@/modules/education/v1/api/v1/questions/Dto/QuestionUuid'

/** PATCH /api/education/v1/questions/{question}: вес и/или данные */
export class ChangeQuestionRoute extends EducationRoute<ChangeQuestionParams, QuestionUuid> {
  constructor(private readonly question: string) {
    super()
  }

  type(): EnumRouteType {
    return EnumRouteType.PATCH
  }

  url(): string {
    return '/api/education/v1/questions/' + this.question
  }

  offline(): Promise<ApiResponse<QuestionUuid>> {
    return Promise.resolve(new ApiResponse({ success: true, data: new QuestionUuid({ uuid: this.question }) }))
  }
}
